<template>
    <span v-if="display">
        <font-awesome-icon v-if="direction === 'asc'" :icon="`sort-${type}-down`" />
        <font-awesome-icon v-else :icon="`sort-${type}-up`" />
    </span>
</template>

<script>
export default {
    name: "SortIcons",
    props: {
        display: Boolean,
        direction: String,
        type: {
            default: 'numeric',
            type: String
        },
    },
}
</script>

<style scoped>

</style>
